import { CloseIcon } from 'src/modules/year-end-forms/styles';
import styled from 'styled-components';

export const UserAdditionBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 15px 25px 10px;
  background: #f3f4f8;
  border-radius: 20px;
  height: 100%;
`;

export const CommonInputDiv = styled.div`
  width: auto;
`;

export const InputContainer = styled.div`
  background-color: white;
  padding: 30px;
  height: 200px;
  width: 100%;
  margin-left: -7px;
  border-radius: 15px;
`;

export const UserAdditionHeader = styled.div`
  text-align: left;
  font: normal normal medium 30px/35px Biotif;
  letter-spacing: -0.33px;
  color: #1c1b3a;
  opacity: 1;
  margin-top: 14px;
  font-size: 30px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 21px;
  margin-right: 15px;

  h3 {
    margin: 0;
    font-size: 26px;
    font-weight: bold;
    color: #333;
  }

  ${CloseIcon} {
    cursor: pointer;
  }
`;

export const UserAdditionFormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  input {
    flex: 1;
  }
`;

export const UserAdditionFormRowLast = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const UserAdditionForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  hieght: 400px;
`;

export const RegularButton = styled.form`
  margin-left: 383px;
`;
